import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingDetail, Payment } from "../../../Models";
import { getValueByLang } from "../../../Utils";
import dayjs from 'dayjs';
import RoomTypeSelectionComponent from "../../common/guestinfo/RoomTypeSelectionComponent";

interface Attrs {    
    agentId: number;
    isMobile?: boolean;
    messageProvider: MessageProvider;
    hotLineNumber?: string|null;
    booking: BookingDetail
}

export default function BookingConfirmationComponent(): m.Component<Attrs> {
    return {
        view(vnode) {     
            const {agentId, isMobile, messageProvider, hotLineNumber, booking} = vnode.attrs;

            let hasDiscount = (ratePerNights) => {
                let filterDiscounts = ratePerNights.filter(ratePerNight => ratePerNight.discountApplied != null);
                return filterDiscounts.length > 0;
            }

            var getCountryNames = new Intl.DisplayNames(['en'], {type: 'region'});
            let nationality = getCountryNames.of(booking.guest.countryCode) || ""

            return m("div",{}, [
                (booking.status == "CONFIRMED")?[
                    m("div.ml-2 mr-2 mt-2 alert alert-success text-center rounded-16", [
                        m("div", [
                            m("i.bi bi-check-circle mr-2"),
                            m("span", messageProvider.get("booking_confirmed"))
                        ]),
                        m("div.font-weight-bold", messageProvider.get("booking_reference") + " : " + booking.reference)
                    ])
                ]:[
                    m("div.ml-2 mr-2 mt-2 alert alert-danger text-center rounded-16", [
                        m("div", [
                            m("i.bi bi-x-circle mr-2"),
                            m("span", messageProvider.get("booking_cancelled"))
                        ]),
                        m("div.font-weight-bold", messageProvider.get("booking_reference") + " : " + booking.reference)
                    ])
                ],
                m("div", {class: (isMobile)? "":"row"}, [
                    m("div.col-md-7 col-12", {class: (isMobile)? "p-0":""}, [
                        m("div.card bg-white ml-2 mb-2 rounded-16", {class: (isMobile)? "mr-2": ""}, [
                            m("div.card-header rounded-top-16", messageProvider.get("booking_summary")),
                            m("div.card-body", [
                                (isMobile)? m("strong", getValueByLang(booking.hotel.name, messageProvider.getCurrentLang())): m("h5", getValueByLang(booking.hotel.name, messageProvider.getCurrentLang())),
                                m("div.d-flex", [
                                    m("div.pr-2", m("i.bi bi-geo-alt")),
                                    m("div", getValueByLang(booking.hotel.address, messageProvider.getCurrentLang()))
                                ]),
                                m("div.pr-2", m("i.bi bi-telephone pr-2"), booking.hotel.phoneNumber),

                               m("div.mt-4 mb-2", m("strong",messageProvider.get("checkin_info"))),
                               m("div.d-flex", [
                                   m("div.pr-2", m("i.bi bi-calendar4-range")),
                                   m("div", dayjs(booking.checkInDate).format("MMM DD, YYYY") + " (" + getValueByLang(booking.hotel.regulation.checkInCheckOutPolicy.checkInTime, messageProvider.getCurrentLang()) + ")",
                                        m("i.bi bi-arrow-right px-1"), 
                                        dayjs(booking.checkOutDate).format("MMM DD, YYYY") + " (" + getValueByLang(booking.hotel.regulation.checkInCheckOutPolicy.checkOutTime, messageProvider.getCurrentLang()) + ")"
                                    )
                                ]),
                               m("div.mt-1", [
                                   m("i.bi bi-door-closed pr-2"),
                                   booking.numberOfRooms + " " + ((booking.numberOfRooms > 1)? messageProvider.get("rooms"):messageProvider.get("room"))
                               ]),
                               m("div.mt-1", [
                                   m("i.bi bi-person pr-2"),
                                   messageProvider.interpolate("number_of_adults", {count:booking.numberOfAdults}),
                                    (booking.hotel.maxChildAge > 0)? 
                                    [
                                        ((messageProvider.getCurrentLang() == "en")?", ": "၊ ") + messageProvider.interpolate("number_of_child", {count: booking.numberOfChildren}),
                                    ]:null
                               ]),
       
                               m("div.pt-4", m("strong", booking.guest.name)),
       
                               (booking.guest.emailAddress != null && booking.guest.emailAddress != "")?
                               m("div.mt-1", [
                                   m("i.bi bi-envelope pr-2"),
                                   booking.guest.emailAddress
                               ]):null,
       
                               m("div.mt-1", [
                                   m("i.bi bi-telephone pr-2"),
                                   booking.guest.cellPhoneNumber
                               ]),
       
                               m("div.mt-1", [
                                   m("i.bi bi-person pr-2"),
                                   nationality
                               ]),
       
                               (booking.specialRequest != null && booking.specialRequest != "")?
                               m("div.mt-1", [
                                   m("i.bi bi-check2-all pr-2"),
                                   booking.specialRequest
                               ]):null,
        
                               m("div.mt-4", [
                                    booking.roomTypeSelections.map((roomTypeSelection, index) => {
                                        return [
                                            m(RoomTypeSelectionComponent, {
                                                messageProvider: messageProvider,
                                                roomTypeSelection: roomTypeSelection
                                            }),
                                            (index < booking.roomTypeSelections.length -1)?
                                            m("div.col-12",m("hr")):null
                                        ]
                                    })
                               ])
                               
                               
                            ])
                        ])
                    ]),
                    m("div.col-md-5 col-12", {class: (isMobile)? "p-0":""},[
                        m("div.card bg-white mr-2 mb-3 rounded-16", {class: (isMobile)? "ml-2": ""}, [
                            ShowPaymentSummary(messageProvider, booking)
                        ]),
                        m("div.card bg-white mr-2 mb-3 rounded-16", {class: (isMobile)? "ml-2": ""}, [
                            m("div.card-header rounded-top-16", messageProvider.get("regulation")),
                            m("div.card-body", [
                                (booking.hotel.regulation.cancellationPolicy != null)?
                                [
                                    m("div.mb-2", (isMobile)? m("strong", messageProvider.get("cancellation_policy")): m("h5", messageProvider.get("cancellation_policy"))),
                                    m("div", m.trust(getValueByLang(booking.hotel.regulation.cancellationPolicy, messageProvider.getCurrentLang())))
                                ]:null,
        
                                (booking.hotel.regulation.termsConditions != null)?
                                [
                                    m("div.mt-4 mb-2", (isMobile)? m("strong", messageProvider.get("terms_and_conditions")): m("h5", messageProvider.get("terms_and_conditions"))),
                                    m("div", m.trust(getValueByLang(booking.hotel.regulation.termsConditions, messageProvider.getCurrentLang())))
                                ]:null
                            ])
                        ]),
                        m("div.mr-2 mb-3", {class: (isMobile)? "ml-2": ""}, [
                            m("div.border border-secondary1 p-3 rounded-16", [
                                m("div", messageProvider.get("help_label")),
                                m("div.pt-2", [
                                    (agentId == 1)?
                                    hotLineNumber !=null ? m.trust(hotLineNumber):"":
                                    booking.hotel.phoneNumber
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        }
    }
}

function ShowPaymentSummary(messageProvider: MessageProvider, booking: BookingDetail){
    let getTotalDeposit = (payments: Payment[]) => {
        let totalDeposit = 0;
        payments.forEach(payment => totalDeposit += payment.amount);
        
        return totalDeposit;
    }

    let totalDeposit = getTotalDeposit(booking.payments)
    let balanceDue = booking.totals.sellRate - totalDeposit

    return m("div", [
        m("div.card-header rounded-top-16", messageProvider.get("payment_summary")),
        m("div.card-body", [
            FlexContentRight(messageProvider.get("room_charges"), new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.roomCharge)),
            FlexContentRight(messageProvider.get("extra_bad_charges"), new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.extraBedCharge)),
            FlexContentRight(messageProvider.get("tax"), new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.taxRate)),
            m("hr.mt-1 mb-2"),
    
            (booking.totals.discountApplied > 0)?
            [
                FlexContentRight(messageProvider.get("sub_total"), new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format((booking.totals.roomCharge + booking.totals.extraBedCharge + booking.totals.taxRate))),
                FlexContentRight(messageProvider.get("discount"), "- " + new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.discountApplied)),
                m("hr.mt-1 mb-2")
            ]:null,
    
            RowColsRight(messageProvider.get("total") + " :", new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.sellRate)),
            RowColsRight(messageProvider.get("deposit_amount") + " :", "- " + new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(totalDeposit)),
            m("hr.mt-1 mb-2"),
    
            m("div.row py-2", [
                m("div.col-8 text-right pr-0 text-muted", messageProvider.get("balance_due") + " :"),
                m("div.col-4 text-right ", {
                    class: (balanceDue > 0)? "text-danger": ""
                }, "MMK " + new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(balanceDue))
            ])
        ])
    ])
}

function FlexContentRight(label:string, content: string){
    return m("div.d-flex py-1", [
        m("div.mr-auto text-muted", label),
        m("div.text-right", content)
    ])
}

function RowColsRight(label: string, content: string){
    return m("div.row py-1", [
        m("div.col-8 text-right pr-0 text-muted", label),
        m("div.col-4 text-right", content)
    ])
}